// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"16d8b259","897":"16d8b259"}[chunkId] + ".chunk.css";
};